import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {SelectFilterComponent} from '../../../../../components/common/select-filter/select-filter.component';
import {UntypedFormGroup} from '@angular/forms';
import {SelectFilterElement} from '../../../../../components/common/select-filter/select-filter.model';
import {Operator, Order, Sort, UrlParameter} from '../../../../../shared/utils/url.builder';
import {TriggerModalCapable} from '../../../../../components/common/modal/triggerModalCapable';
import {ProductModalOptions} from './productModalOptions';
import {NewItemModalOptions} from '../../../../core/component/select/abstract-select.component';
import {
    ProductSaveDialogInput,
    ProductSaveDialogResult,
    ProductSaveModalComponent
} from '../product-save-modal/product-save-modal.component';
import {ProductFindAllService} from '../../../impl/service/productFindAll.service';
import {ProductSummaryModel} from '../../entity/productSummary.model';

@Component({
    selector: 'app-product-select-filter',
    templateUrl: './product-select-filter.component.html',
    viewProviders: [ProductFindAllService]

})
export class ProductSelectFilterComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges, TriggerModalCapable<ProductModalOptions> {

    loading$: Observable<boolean>;
    subscription: Subscription;

    @ViewChild('selectFilter') selectFilterComponent: SelectFilterComponent<number, ProductSummaryModel>;

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() noValueLabel: 'Aucun produit';
    @Input() typeValue;
    @Input() categoryValue;
    @Input() newItemModalOptions: ProductModalOptions;

    @Output() _onSingleSelectionChange = new EventEmitter<ProductSummaryModel>();
    @Output() productsLoadedEvent: EventEmitter<ProductSummaryModel[]> = new EventEmitter<ProductSummaryModel[]>();

    elements: BehaviorSubject<SelectFilterElement<number, ProductSummaryModel>[]> =
        new BehaviorSubject<SelectFilterElement<number, ProductSummaryModel>[]>([]);
    parameters: UrlParameter[] = [];

    constructor(private service: ProductFindAllService) {
        this.service.sort = new Sort('label', Order.ASCENDING);
    }

    ngOnInit() {
        this.service.entities$.subscribe(entities => {
            this.elements.next(entities.map(value => new SelectFilterElement(value.id, value.id, value)))
            this.productsLoadedEvent.emit(entities);
        });
        this.buildParameters();
        this.refresh();
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['typeValue']) {
            this.buildParameters();
            if (!changes['typeValue'].isFirstChange()) {
                this.refresh();
            }
        }
    }

    buildParameters() {
        this.parameters = [];
        this.parameters.push(new UrlParameter('active', true, Operator.EQUALS));
        if (this.typeValue) {
            this.parameters.push(new UrlParameter('type.value', this.typeValue, Operator.EQUALS));
        }
        if (this.categoryValue) {
            this.parameters.push(new UrlParameter('category.value', this.categoryValue, Operator.EQUALS));

        }
    }

    refresh() {
        this.service.additionalParameters = this.parameters;
        this.service.findAll();
    }


    ngAfterViewInit(): void {
        this.loading$ = this.service.loading$;
    }

    filter = (criteria: string, entity: ProductSummaryModel) => {
        const name = entity.label + ' ' + entity.category?.label;
        return (name).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
    }

    selectionChanged(value: SelectFilterElement<number, ProductSummaryModel>) {
        if (value) {
            this._onSingleSelectionChange.emit(value.element);
        }
    }

    public getSelectedElement(): ProductSummaryModel {
        return this.selectFilterComponent?.getSelectedElement();
    }

    get formattedNewItemModalOptions(): NewItemModalOptions<ProductSaveDialogResult, ProductSaveDialogInput, ProductSaveModalComponent>{
        return this.newItemModalOptions ? ({
            dialogOption: {
                title: this.newItemModalOptions.typeValue
            },
            componentType: ProductSaveModalComponent,
            dialogInput: {
                typeValue: this.newItemModalOptions.typeValue
            },
            valueNewItemMapper: this.valueNewItemMapper,
        }) : undefined;
    }

    valueNewItemMapper = (result: ProductSaveDialogResult) => {
        return result?.entity?.summary?.id;
    }
}
